<template>
  <div class="main_center" style="margin: 0 0; padding-top: 8px;">
    <div class="content" style="padding: 16px 16px 10px 16px;">

      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
            <el-col :span="8">
              <el-form-item label="姓名：" >
                <el-input v-model="form.personName" clearable @keydown.enter.native.stop="getDataList"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" >
                <el-form-item label="身份证号：" >
                    <el-input v-model="form.idcard" clearable @keydown.enter.native.stop="getDataList"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-form-item label="角色：" props="roleType">
                <el-select v-model="form.roleType" clearable value-key="value" style="width:100%;"  @change="seachBtn">
                  <el-option label="全部" value="-99"></el-option>
                  <el-option v-for="(item,index) in  rolesList"
                             :key="index"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="交易中心：">
                <el-select v-model="form.tradeId" clearable value-key="value" style="width:100%;" @change="seachBtn">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="(item,index) in transactionCenterList" :key="index" :label="item.orgName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :span="8">
              <el-form-item label="">
                <div >
    <!--            <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true"
                           icon="el-icon-arrow-down">展开
                </el-button>
                <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false"
                           icon="el-icon-arrow-up">收起
                </el-button>-->
                <el-button size="mini" type="primary" @click="seachBtn">搜索</el-button>
                <el-button plain size="mini" type="primary" @click="reflash">重置</el-button>
              </div>
              </el-form-item>
            </el-col>
            
        </el-row>
      </el-form>
      <div style="position: relative;top:-10px">
        <el-button size="mini"  icon="el-icon-plus" v-if="hasBtnPermission('btn_jz_facial_info_edit')" type="primary" @click="routerAdd">新增</el-button>
        <el-button size="mini" icon="el-icon-delete" v-if="hasBtnPermission('btn_jz_facial_info_delete')"  type="primary" @click="deleteSelectItem()">删除</el-button>
      </div>

      <space :left="-16" :right="-16" :bottom="16" />



      <el-table :data="tableData"
                ref="multipleTable"
                :height="tableMaxHeight"
                v-loading="dataListLoading"
                stripe
                border
                @selection-change="handleSelectionChange">
        <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_jz_facial_info_delete')" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" title="编辑"
                       v-if="hasBtnPermission('btn_jz_facial_info_edit')"
                       @click="router(scope.row)">编辑</el-button>
            <el-button type="text" title="删除"
                       v-if="hasBtnPermission('btn_jz_facial_info_delete')"
                       @click="deleteById(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>


        <el-table-column label="头像缩略图" align="center" width='100'>
            <template slot-scope="scope">
                <img :src="scope.row.imgUrl" v-if="scope.row.imgUrl" class="thumbnail" alt="">
            </template>
        </el-table-column>
        <el-table-column label="姓名" prop='personName' header-align="center" align="center" min-width='120'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="身份证号" prop='idcard' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="角色" prop='roleTypeName' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="申请时间" prop='createTime' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
      <!-- <el-pagination background
                     layout="sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination> -->
        <pagination
            class="limit"
            :page-sizes="[10, 20, 50, 100]"
            :total="total"
            :page.sync="pageIndex"
            :limit.sync="pageSize"
            @pagination="paginationChange">
        </pagination>
    </div>
  </div>
</template>

<script>
    import {mapState} from "vuex";
    import space from "../../common/components/space.vue";
    import Pagination from '@/components/Pagination.vue';
    export default {
      components: {
        space,
        Pagination
      },
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 267,
        dataListLoading: false,
      form: {
          personName:"",
          idcard:"",
        search:'' ,//搜索框的值
        roleType:'-99',
        tradeId: '', // 交易中心ID
      },

      moreSearchItem: false,
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {},
       rolesList:[],
      transactionCenterList: [],
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
    created() {
        this.getDic('jz_dgwitness_person_role');
        this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
    },
    activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    // this.reflash();
    this.getDataList()

  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {
      let hasBtnPermisson = this.hasBtnPermission("btn_jz_facial_info_edit") || this.hasBtnPermission("btn_jz_facial_info_delete");
      let tableMaxHeight = document.documentElement.clientHeight - 407 +  (hasBtnPermisson ? 0 : 33);
      this.pageSize = parseInt((tableMaxHeight) / 70) || 1;
        this.$nextTick(() => {
            this.tableMaxHeight = tableMaxHeight
        })
      //this.getDataList()
    },

    getDic(type) { // 获取字典

      this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_person_role':this. rolesList = res.data.data;break;
          }
        }
      })
    },



    getDataList() { // 获取列表数据
        this.dataListLoading=true;
      this.$http.post('/document/sysPersonFaces/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
          roleType:this.form.roleType=="-99"?"":this.form.roleType,
          personName:this.form.personName,
          idcard:this.form.idcard,
          tradeId: this.form.tradeId

      }).then(res => {
          if(res.data.code =="1"){

              const data = res.data.data;
              this.tableData = data.rows;
              this.total = data.total;
              this.$refs.multipleTable.doLayout()
          }else{
              this.tableData =[];
              this.total = 0;
              this.$refs.multipleTable.doLayout()
          }
          this.dataListLoading=false;

      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seachBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    reflash() {//刷新按钮
        this.pageIndex = 1;
        this.$refs['form'].resetFields();
        this.form.roleType='-99';
        this.form.personName='';
        this.form.idcard='';
        this.form.tradeId = '';
        this.getDataList()

    },

      routerAdd(){
          this.$router.push({
              name:'facial_info_detail',
              query:{
                  id:''
              }
          })
      },

    router(item){ // 跳转详情

      this.$router.push({
        name:'facial_info_detail',
        query:{
          id:item.id
        }
      })

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      this.$http.post('/document/sysPersonFaces/delete', {
        id: item.id
      }).then(res => {
        if (res.data.code == '1') {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.getDataList();
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })

      if (ids != "" || ids.length > 0) {
        this.$http.post('/cateQuestBase/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
    },

  }


}
</script>

<style lang="less">

    .thumbnail{
        width: 50px;
        height: 50px;
    }

.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>